import { render } from "./IconGrade.vue?vue&type=template&id=64ef0844"
import script from "./IconGrade.vue?vue&type=script&lang=js"
export * from "./IconGrade.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__